import { authenticated } from './WebRequest';
import type {
  ActivationCertificate,
  ApiThunk,
  LicenseCode,
  LicenseStatusResponse,
  LicensingErrorNumber,
  LicensingActionResponse,
  LicensingVersionInfoResponse,
} from './types/Protection';

export type {
  ActivationCertificate,
  ApiThunk,
  LicenseCode,
  LicenseFeature,
  LicenseStatusCode,
  LicenseStatusResponse,
  LicensingActionResponse,
  LicensingErrorNumber,
  LicensingVersionInfoResponse,
} from './types/Protection';

export default class LicensingAPI {
  static LicenseStatus(): ApiThunk<LicenseStatusResponse> {
    return authenticated.get('/licensing/status');
  }

  static ActivateOnline(
    licensecode: LicenseCode
  ): ApiThunk<LicensingActionResponse> {
    return authenticated.post('/licensing/activate_online', { licensecode });
  }

  static DeactivateOnline(): ApiThunk<LicensingActionResponse> {
    return authenticated.get('/licensing/deactivate_online');
  }

  static ActivationCertificateRequest(
    licensecode: LicenseCode
  ): ApiThunk<ActivationCertificate> {
    return authenticated.post('/licensing/activation_certificate_request', {
      licensecode,
    });
  }

  static ActivateOffline(
    certificate: ActivationCertificate
  ): ApiThunk<LicensingActionResponse> {
    return authenticated.post('/licensing/activate_offline', { certificate });
  }

  static ActivationCertificateReset(): ApiThunk<null> {
    return authenticated.get('/licensing/activation_certificate_reset');
  }

  static DeactivationCertificateRequest(): ApiThunk<ActivationCertificate> {
    return authenticated.get('/licensing/deactivation_certificate_request');
  }

  static ErrorMessage(error_no: LicensingErrorNumber): ApiThunk<string> {
    return authenticated.post('/licensing/activate_offline', { error_no });
  }

  static VersionInfo(): ApiThunk<LicensingVersionInfoResponse> {
    return authenticated.get('/licensing/version_info');
  }
}
